import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchmarchand'
})
export class SearchmarchandPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value) return null;
    if(!args) return value;

    args = args.toLowerCase();

    return value.filter((item: any) => {
      return JSON.stringify(item.nom).toLowerCase().includes(args) || JSON.stringify(item.code_boutique).toLowerCase().includes(args);
    })
  }
}